import gql from 'graphql-tag';

export const GET_SITEINI_COUNTRIES = gql`
  {
    siteiniCountryList {
      name
      siteiniCount
      lockedCount
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/siteini/countries.js